import { Resource } from "data/Resource";
import { del, get, post } from "lib/API";

export const getAllResources = async (
    _: any[],
    { token }: any
): Promise<Resource[]> => {
    return await get('v2/resource', token);
};

export const getVendorsResources = async (
    [vendorIds]: any[],
    { token }: any
): Promise<Resource[]> => {
    return await post('v2/resource/getVendorResources', token, { vendorIds: vendorIds });
};

export const createResource = async (
    [resources]: any[],
    { token }: any
): Promise<Resource[]> => {
    return await post('v2/resource', token, resources);
};

export const deleteResource = async (
    [resourceId]: any[],
    { token }: any
): Promise<Resource[]> => {
    return await del(`v2/resource/${resourceId}`, token);
};

export const getYoutubeVideoTitle = async (
    [url]: any[],
    { token }: any
) => {
    if(url){
        return await get(`v2/resource/youtube-title`, token, { url });
    }
    return null;
}